export default [
  {
    path: '/settings/replacements',
    name: 'replacements',
    component: () => import('./_views/PbReplacements.vue'),
    meta: {
      title: 'Replacements',
      group: 'settings',
      navigation: {
        name: 'Replacements',
        specialQueries: ['suffix'],
        to: {
          name: 'replacements',
          query: {
            suffix: '',
          },
        },
      },
    },
  },
];
